<div class="message-taking-banner">
  <button class="dismiss-btn" (click)="dismiss()" type="button">
    <ng-icon name="heroXMark"></ng-icon>
  </button>

  <span class="new-pill">{{ 'TAKE_MESSAGES.SCENARIOS.BANNER_LABEL' | translate }}</span>

  <div class="banner-illustration" aria-hidden="true">
    <svg viewBox="0 0 210 102" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
      <g transform="rotate(8 138.5 65)" opacity="0.6">
        <rect x="105" y="33" width="67" height="64" rx="5.79" fill="#fafafa" stroke="rgba(42,20,60,0.04)"/>
        <rect x="115" y="46" width="44" height="5" rx="2.5" fill="#e9e7ed"/>
        <rect x="115" y="54" width="32" height="5" rx="2.5" fill="#e9e7ed"/>
        <rect x="115" y="62" width="38" height="5" rx="2.5" fill="#e9e7ed"/>
        <rect x="115" y="70" width="49" height="5" rx="2.5" fill="#e9e7ed"/>
        <rect x="115" y="78" width="44" height="5" rx="2.5" fill="#e9e7ed"/>
        <circle cx="139" cy="33" r="8" fill="#d7d2dc"/>
        <text x="139" y="36.6" font-family="Outfit, sans-serif" font-size="9" font-weight="600" fill="#fff" text-anchor="middle">B</text>
      </g>
      <g transform="rotate(-8 75.5 65)">
        <rect x="42" y="33" width="67" height="64" rx="5.79" fill="#fff" stroke="rgba(42,20,60,0.04)"/>
        <rect x="52" y="46" width="44" height="5" rx="2.5" fill="#f4e9fe"/>
        <rect x="52" y="54" width="32" height="5" rx="2.5" fill="#f4e9fe"/>
        <rect x="52" y="62" width="38" height="5" rx="2.5" fill="#f4e9fe"/>
        <rect x="52" y="70" width="49" height="5" rx="2.5" fill="#f4e9fe"/>
        <rect x="52" y="78" width="44" height="5" rx="2.5" fill="#f4e9fe"/>
        <circle cx="73" cy="33" r="8" fill="#c48af6"/>
        <text x="73" y="36.6" font-family="Outfit, sans-serif" font-size="9" font-weight="600" fill="#fff" text-anchor="middle">A</text>
      </g>
      <g transform="translate(95 56)">
        <path d="M10.4836 27.5003C10.4836 28.0526 10.9314 28.5003 11.4836 28.5003C12.0359 28.5003 12.4836 28.0526 12.4836 27.5003H11.4836H10.4836ZM4.31513 0.0568123C3.79407 -0.126262 3.22326 0.147728 3.04019 0.668787L0.0568123 9.15993C-0.126262 9.68099 0.147728 10.2518 0.668787 10.4349C1.18985 10.6179 1.76066 10.344 1.94373 9.8229L4.59562 2.27522L12.1433 4.92711C12.6644 5.11018 13.2352 4.83619 13.4182 4.31513C13.6013 3.79407 13.3273 3.22326 12.8063 3.04019L4.31513 0.0568123ZM11.4836 27.5003H12.4836C12.4836 22.8228 10.9369 13.1752 4.88517 0.567541L3.98365 1.00027L3.08212 1.433C9.03044 13.8253 10.4836 23.1777 10.4836 27.5003H11.4836Z" fill="url(#mtb-arrow-gradient)"/>
      </g>
      <defs>
        <linearGradient id="mtb-arrow-gradient" x1="7.73" y1="56" x2="7.73" y2="84.5" gradientUnits="userSpaceOnUse">
          <stop stop-color="#9332E0"/>
          <stop offset="1" stop-color="#AD5DEF" stop-opacity="0.5"/>
        </linearGradient>
      </defs>
    </svg>
  </div>

  <div class="banner-bottom">
    <p class="eyebrow">{{ 'TAKE_MESSAGES.SCENARIOS.BANNER_EYEBROW' | translate }}</p>
    <div class="title-row">
      <p class="title-text">{{ 'TAKE_MESSAGES.SCENARIOS.BANNER_DESCRIPTION' | translate }}</p>
      <button class="cta-btn" (click)="navigate()" type="button" [attr.aria-label]="'TAKE_MESSAGES.SCENARIOS.BANNER_EYEBROW' | translate">
        <ng-icon name="heroArrowRightMini"></ng-icon>
      </button>
    </div>
  </div>
</div>
